import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import Button from '../ui/Button';
import { SwooshAccent } from '../ui/DecorativeElements';

const { FiArrowRight } = FiIcons;

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center pt-24 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782379358/1_w652kx.png" 
          alt="Construction Safety Training" 
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-navy-gradient opacity-85 mix-blend-multiply"></div>
      </div>

      {/* Decorative Swoosh */}
      <SwooshAccent className="bottom-0 left-0 w-full h-64 text-alpha-green/20 z-10" />

      <div className="container mx-auto px-6 max-w-7xl relative z-20">
        <div className="max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-6">
              Building Safer Workplaces Through <span className="text-alpha-green">Knowledge & Training</span>
            </h1>
          </motion.div>
          
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg md:text-xl text-alpha-grayLight mb-10 leading-relaxed"
          >
            Professional workforce training solutions for employers, domestic workers, foreign workers, and corporate organizations. Accredited, reliable, and human-centered.
          </motion.p>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex flex-col sm:flex-row gap-4"
          >
            <Button variant="primary" className="group">
              Explore Training Programs
              <SafeIcon icon={FiArrowRight} className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button variant="white">
              Contact Us
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;